<template>
  <div>
    <div class="d-flex flex-row" style="">
      <div class="flex-col mr-auto">
        <h4>{{ day.name }}</h4>
      </div>
      <div class="flex-col">
        <button class="btn btn-link" type="button" @click="startEditDay"><i class="mdi mdi-pencil"></i> Edit</button>
        <!-- <div class="btn-group">
          <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Edit
          </button>
          <div class="dropdown-menu dropdown-menu-right">
            <button class="dropdown-item" type="button" @click="startEditDay">Edit Day</button>
          </div>
        </div> -->
      </div>
    </div>
    <div v-if="day.description"
      class="alert alert-light p-1 m-0 border-light"
      style="white-space: pre-wrap"
      v-text="day.description">
    </div>

    <div v-for="(group, index) in day.groups" v-bind:key="index">
      <WorkoutPlanPanelExerciseGroup :index="index" :initial-workout-group="group" @workout-group-updated="onGroupUpdated"/>
    </div>
    <button class="btn btn-link p-0" type="button" @click="startAddExerciseGroup"><i class="mdi mdi-plus"></i>Add Exercise Group</button>

    <form-modal v-if="showAddExerciseGroupModal" @close="showAddExerciseGroupModal=false" @submitted="addExerciseGroup">
      <h3 slot="header">Add Exercise Group</h3>
      <div slot="body">
        <div class="form-row align-items-center mb-2">
          <div class="col-3">
            <label for="exercise-group-to-add-name">Name</label>
          </div>
          <div class="col">
            <input
              class="form-control"
              placeholder="e.g. Warmup, Cooldown, etc."
              id="exercise-group-to-add-name"
              required
              v-model="exerciseGroupToAddDetails.name"
            />
          </div>
        </div>
        <div class="form-row align-items-center mb-2">
          <div class="col-3">
            <label for="exercise-group-to-add-description">Description</label>
          </div>
          <div class="col">
            <textarea
              class="form-control"
              placeholder="Add any notes here"
              id="exercise-group-to-add-description"
              v-model="exerciseGroupToAddDetails.description"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <button type="reset" class="btn btn-default" @click="showAddExerciseGroupModal = false">
          Cancel
        </button>
        <button type="submit" class="btn btn-primary">
          Add Exercise Group
        </button>
      </div>
    </form-modal>
    <form-modal v-if="showEditDayModal" @close="showEditDayModal=false" @submitted="updateDay">
      <h3 slot="header">Update Day: {{ day.name }}</h3>
      <div slot="body">
        <div class="form-row align-items-center mb-2">
          <div class="col-3">
            <label for="day-edit-name">Name</label>
          </div>
          <div class="col">
            <input
              class="form-control"
              placeholder="e.g. Upper Body 1, Tuesday, etc."
              id="day-edit-name"
              required
              v-model="editedDayDetails.name"
            />
          </div>
        </div>
        <div class="form-row align-items-center mb-2">
          <div class="col-3">
            <label for="day-edit-description">Description</label>
          </div>
          <div class="col">
            <textarea
              class="form-control"
              placeholder="Add any notes here"
              id="day-edit-description"
              v-model="editedDayDetails.description"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <button type="reset" class="btn btn-default" @click="showEditDayModal = false">
          Cancel
        </button>
        <button type="submit" class="btn btn-primary">
          Update Day
        </button>
      </div>
    </form-modal>
  </div>
</template>
<script>
  import WorkoutPlanPanelExerciseGroup from '@coach/js/components/WorkoutPlanPanelExerciseGroup.vue'

  export default {
    props: [
        'initialDay'
    ],
    components: {
      WorkoutPlanPanelExerciseGroup
    },
    data() {
      return {
        day: this.initialDay,
        showAddExerciseGroupModal: false,
        exerciseGroupToAddDetails: {
          'name': null,
          'description': null
        },
        showEditDayModal: false,
        editedDayDetails: {
          'name': this.initialDay.name,
          'description': this.initialDay.description
        }
      }
    },
    mounted() {
    },
    computed: {
      intakeUpdatedSinceLastUpdated: function() {
        return this.day.updated_at < this.$root.plan.intake_updated_at;
      },
    },
    methods: {
      onGroupUpdated: function() {
        var _this = this;
        // axios.get('/api/workout_plan_days/' + _this.day.id).then(function (response) {
        //     _this.day = response.data.data;
        //     _this.$emit('day-updated', _this.day);
        // });
        _this.$emit('day-updated');
      },
      startAddExerciseGroup: function () {
        this.showAddExerciseGroupModal = true;
        this.$nextTick(function(){
          document.getElementById('exercise-group-to-add-name').focus();
          // this.$refs.exercise_filter_input.focus();
        }.bind(this));
      },
      addExerciseGroup: function () {
        var _this = this;
        axios.post('/api/workout_plan_exercise_groups', {
          'workout_plan_day_id': this.day.id,
          'name': this.exerciseGroupToAddDetails.name,
          'description': this.exerciseGroupToAddDetails.description,
        }).then((response) => {
          _this.exerciseGroupToAddDetails = {
            'name': null,
            'description': null
          };
          // _this.day.groups.push(response.data.data);
          _this.showAddExerciseGroupModal = false;
          _this.$emit('day-updated');
        });
      },
      startEditDay: function () {
        var _this = this;
        _this.showEditDayModal = true;
        this.$nextTick(function(){
          document.getElementById('day-edit-name').focus();
          // this.$refs.day_edit_name.focus();
        }.bind(this));
      },
      updateDay: function () {
        var _this = this;
        axios.put('/api/workout_plan_days/'+ this.day.id, {
          'name': this.editedDayDetails.name,
          'description': this.editedDayDetails.description,
        }).then((response) => {
          // _this.editedDayDetails = {
            //   'name': null,
          //   'description': null
          // };
          // Object.assign(_this.day, response.data.data); // merge instead
          _this.showEditDayModal = false;
          _this.$emit('day-updated');
        }).catch(e => {
          console.log(e);
            _this.errorBag = e.response.data;
            _this.showEditDayModal = false;
        });
      },
    },
    watch: {
      initialDay: function (newVal,oldVal) {
        Vue.set(this, 'day', newVal);
      }
    }
}
</script>
